export class HAConfig {
    currentHostIp: string;
    primaryHostName: string;
    primaryHostIp: string;
    secondaryHostName: string;
    secondaryHostIp: string;
    dbType: string;
    useHa: boolean;

    constructor(){
        this.currentHostIp = '';
        this.primaryHostName = 'PrimaryHost';
        this.primaryHostIp = '10.0.0.1';
        this.secondaryHostName = 'SecondaryHost';
        this.secondaryHostIp = '10.0.0.2';
        this.dbType = 'MSSQL_EXPRESS';
        this.useHa = false;
    }
}

